import type { FormikErrors } from 'formik'
import type { Referral } from '../../../oppsync/modules/CoSell/reducer'
import type { ReferralOppSections } from '../../../oppsync/modules/CoSell/ReferralForm/reducer'

/** Flattens nested Formik section errors into Referral field keys (no runtime import of ReferralForm actions). */
export const formikErrorsToReferral = (
  errors: FormikErrors<ReferralOppSections>
): Record<string, string> => {
  const buffer = {} as Record<string, string>
  for (const key in errors) {
    const nestedErrors = errors[key as keyof ReferralOppSections] as
      | Record<string, string>
      | undefined
    if (nestedErrors) {
      for (const subKey in nestedErrors) {
        buffer[subKey as keyof Referral] = nestedErrors[subKey]
      }
    }
  }
  return buffer
}
